module.exports = __webpack_public_path__ + "img/graph.1b76565a.svg";